import styled from 'styled-components';
import {
  Label as BaseLabel,
  Input as BaseInput,
  Button,
  CTAButtonLink,
  RawButton,
  CTAButton,
  CancelButton,
} from 'styles/elements';
import { rgba } from 'styles/utils/color';

export const Label = styled(BaseLabel)``;

export const Input = styled(BaseInput)`
  &:disabled {
    color: ${({ theme }) => theme.color.textSecondary};
    background-color: ${({ theme }) => theme.color.backgroundDistinct};
    border-color: ${({ theme }) => theme.color.border};
    opacity: 0.9;
  }
`;

export const LinkDescription = styled.div`
  color: ${({ theme }) => theme.color.textSecondary};
  font-size: 14px;
`;

export const ViewLink = styled.div`
  color: ${({ theme }) => theme.color.buttonPrimary};
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  text-decoration: underline;
`;

export const SubscriptionStatus = styled.div`
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1;
  font-weight: 700;
  text-align: center;
  display: flex;
  align-items: center;
`;

export const StatusActive = styled(SubscriptionStatus)`
  border: 2px solid ${({ theme }) => theme.color.cta};
  background-color: rgba(48, 168, 79, 0.15);
  color: ${({ theme }) => theme.color.cta};
`;

export const StatusEnding = styled(SubscriptionStatus)`
  border: 2px solid ${({ theme }) => theme.color.error};
  background-color: rgba(255, 25, 74, 0.15);
  color: ${({ theme }) => theme.color.error};
`;

export const LogoutButton = styled(Button)`
  background-color: ${({ theme }) => theme.color.error};
  border-color: ${({ theme }) => theme.color.error};
  width: auto;
  height: auto;
  font-size: 12px;
  padding: 2px 10px;

  &:hover {
    color: ${({ theme }) => theme.color.error};
    background-color: ${({ theme }) => theme.color.textPrimary};
  }
`;

export const UpgradeBox = styled.div`
  border: 2px solid ${({ theme }) => theme.color.buttonPrimary};
  background-color: ${({ theme }) => rgba(theme.color.buttonPrimary, 0.15)};
  line-height: 1;
`;

export const UpgradeButtonLink = styled(CTAButtonLink)`
  width: auto;
`;

export const UpgradeButton = styled(CTAButton)`
  width: auto;
  font-weight: 700;
  font-size: 14px;
`;

export const SessionLink = styled.a<{ isCreatingSession: boolean }>`
  cursor: ${({ isCreatingSession }) => (isCreatingSession ? 'default' : 'pointer')};
  opacity: ${({ isCreatingSession }) => (isCreatingSession ? 0.6 : 1)};
`;

interface SliderWrapperProps {
  customWidth?: number;
}

const FEATURES_WIDTH = 152;
const FEATURES_HEIGHT = 42;
const SLIDER_PAD = 6;
const BORDER_WIDTH = 4;

export const DiscordButton = styled.a<{ isDisabled: boolean }>`
  background-color: #7289da;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  width: ${FEATURES_WIDTH - 2}px;
  height: ${FEATURES_HEIGHT - 4}px;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
  transition: opacity 250ms ease;
  flex-shrink: 0;
`;

export const SliderWrapper = styled.div<SliderWrapperProps>`
  border-radius: 4px;
  padding: ${SLIDER_PAD}px;
  height: ${FEATURES_HEIGHT}px;
  width: ${(props) => `${props?.customWidth || FEATURES_WIDTH}px`};
  background-color: ${({ theme }) => theme.color.backgroundDistinct};
  display: flex;
  align-items: center;
  position: relative;
  border: ${BORDER_WIDTH / 2}px solid ${({ theme }) => theme.color.border};
`;

export const SliderActive = styled.div<{ tabs: number; activeTab: number }>`
  width: calc(${({ tabs }) => `(100% - ${2 * SLIDER_PAD}px) / ${tabs}`});
  background-color: ${({ theme }) => theme.color.buttonPrimary};
  height: ${FEATURES_HEIGHT - 2 * SLIDER_PAD - BORDER_WIDTH}px;
  transform: translateX(calc(${({ activeTab }) => activeTab * 100}% - ${SLIDER_PAD}px));
  transition: transform 200ms linear;
  position: absolute;
  top: ${SLIDER_PAD}px;
  bottom: ${SLIDER_PAD}px;
  left: ${2 + BORDER_WIDTH + SLIDER_PAD}px;
  z-index: 0;
  border-radius: 2px;
  box-shadow: ${({ theme }) => theme.shadow.low};
`;

export const SliderButton = styled(RawButton)<{ tabs: number }>`
  width: ${({ tabs }) => 100 / tabs}%;
  position: relative;
  z-index: 1;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  &:focus {
    outline: none;
  }
`;

export const UsernameButton = styled(RawButton)`
  display: flex;
  border-left: 1px solid ${({ theme }) => theme.color.border};
  border-radius: 0.15rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  transition: background-color 200ms ease;
  color: ${(props) => props.theme.color.textPrimary};
  border: 2px solid ${(props) => props.theme.color.cta};
  background-color: ${(props) => props.theme.color.cta};
  font-weight: 600;

  &:hover {
    background-color: ${(props) => props.theme.color.textPrimary};
    border-color: ${(props) => props.theme.color.textPrimary};
    color: ${(props) => props.theme.color.cta};
  }
`;

export const SubmitButton = styled(CTAButton)``;

export const ChangeUsernameButton = styled(CancelButton)`
  background: transparent;
  border-color: white;
`;

export const InlineCheckbox = styled.input`
  margin-top: 0;
  margin-right: 10px;
  margin-left: 0;
  flex: 0 0 auto;
  border-style: none;
  background-color: #20222b;
  transition: border-color 0.2s ease, background-color 0.2s ea;
  width: 16px;
  height: 16px;
`;

export const CheckboxInlineLabel = styled.span`
  letter-spacing: 0.4px;
  padding-left: 0;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  display: inline-block;
  cursor: pointer;
  margin-bottom: 0;
`;

export const InlineCheckboxWrapperLabel = styled(Label)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
`;
